'use strict';

var _ = require('lodash');
var RulesDemandTypeOptionsDirective = function RulesDemandTypeOptionsDirective(StrategyConstants) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/rules-demand-type-options.html'),
    scope: {
      entity: '=',
      groupIndex: '=?'
    },
    link: function link(scope) {
      scope.isDisabled = function () {
        var domain = _.get(scope, 'entity.old.primaryCriteriaLevel.domain');
        return _.get(scope, 'entity.old.flowType') || domain === 'MarketDemandClassGroup';
      };
      scope.getFlowTypeOptions = function () {
        var domain = _.get(scope, 'entity.primaryCriteriaLevel.domain');
        return _.get(StrategyConstants.FlowTypeDisplayedNames, domain, StrategyConstants.FlowTypeDisplayedNames["default"]);
      };
    }
  };
};
RulesDemandTypeOptionsDirective.$inject = ['StrategyConstants'];
module.exports = RulesDemandTypeOptionsDirective;